export const ITEMS_PER_PAGE = 20;
export const ASC = 'asc';
export const DESC = 'desc';
export const SORT = 'sort';

export const paginationKeys = {
  MY_CASES: 'my-cases',
  PARTICIPANT_CASES: 'participant-cases',
  NOTIFICATION_OVERVIEW: 'notification-overview',
  ADMINISTRATIVE_UNIT_OVERVIEW: 'administrative-unit-overview',
  ADMINISTRATIVE_UNIT_SEARCH: 'administrative-unit-search',
  PUBLIC_AUTHORITY_OVERVIEW: 'public-authority-overview',
  CHAMBER_MEMBER_OVERVIEW: 'chamber-member-overview'
};

export const getPaginationSearchParam = (paginationKey: string) => {
  return localStorage.getItem(`${paginationKey}-searchParam`);
};

export const getPaginationFilter = (paginationKey: string) => {
  return JSON.parse(localStorage.getItem(`${paginationKey}-filter-form`));
};
